import React, { useState } from "react";
import { Box, Button, Anchor, Text } from "grommet";
import { History } from "grommet-icons";

import { ServiceHistory as ServiceHistoryV2 } from "./v2/ServiceHistory";


const ShowServiceHistory = ({
    env,
    host,
    service,
    instance,
    mdsConsumer = false,
    ocServiceName = ""
}) => {
    const [showServiceHistory, setShowServiceHistory] = useState(false);

    return (
        <>
            <Box
                justify="center"
                align="center"
                gap="none"
                background="dark-2"
                alignSelf="center"
                width="120px"
                alignContent="center"
                round="xsmall"
            >
                <Anchor
                    alignSelf="center"
                    margin={{ left: "6px", right: "6px" }}
                    onClick={() => {
                        setShowServiceHistory(true);
                    }}
                >
                    <Button
                        plain
                        color="white"
                        label={
                            <Text size="12px" weight="normal">
                                ZK History
                            </Text>
                        }
                        margin={{ top: "xxsmall" }}
                        hoverIndicator={{ color: "light-1", opacity: "weak" }}
                        icon={<History size="16px" color="white" />}
                    />
                </Anchor>
            </Box>

            {showServiceHistory && (
                <ServiceHistoryV2
                    env={env}
                    host={host}
                    service={service}
                    instance={instance}
                    setShowServiceHistory={setShowServiceHistory}
                    mdsConsumer={mdsConsumer}
                    ocServiceName={ocServiceName}
                />
            )}
        </>
    );
};

export default ShowServiceHistory;